import { useCallback, useMemo, useRef } from 'react';
import { useCardLocationContext } from '../internal/CardLocationContext';
import I18n from 'I18n';
import formatRelativeDuration from 'I18n/utils/formatRelativeDuration';
const ABOUT_SIGNALS_SECTION_CONTAINER_FEATURE = 'ABOUT_SIGNALS_SECTION';
const ABOUT_FEEDBACK_SECTION_CONTAINER_FEATURE = 'ABOUT_FEEDBACK_SECTION';
const REVENUE_QUOTE_TO_CASH_SECTION_CONTAINER_FEATURE = 'REVENUE_QUOTE_TO_CASH_SECTION';
const REVENUE_ECOMMERCE_SECTION_CONTAINER_FEATURE = 'REVENUE_ECOMMERCE_SECTION';
const REVENUE_SIGNALS_SECTION_CONTAINER_FEATURE = 'REVENUE_SIGNALS_SECTION';
const CATCH_UP_OVERVIEW_SECTION_CONTAINER_FEATURE = 'CATCH_UP_OVERVIEW_SECTION';
const CATCH_UP_HEALTH_SECTION_CONTAINER_FEATURE = 'CATCH_UP_HEALTH_SECTION';
const CATCH_UP_DATA_QUALITY_SECTION_CONTAINER_FEATURE = 'CATCH_UP_DATA_QUALITY_SECTION';
const HUBSPOT_DEFINED_SECTION_CONTAINER_FEATURES = [ABOUT_SIGNALS_SECTION_CONTAINER_FEATURE, ABOUT_FEEDBACK_SECTION_CONTAINER_FEATURE, REVENUE_QUOTE_TO_CASH_SECTION_CONTAINER_FEATURE, REVENUE_ECOMMERCE_SECTION_CONTAINER_FEATURE, REVENUE_SIGNALS_SECTION_CONTAINER_FEATURE, CATCH_UP_OVERVIEW_SECTION_CONTAINER_FEATURE, CATCH_UP_HEALTH_SECTION_CONTAINER_FEATURE, CATCH_UP_DATA_QUALITY_SECTION_CONTAINER_FEATURE];
export const useTrackContainerCollapseChange = ({
  containerLabel,
  containerFeatures = []
}) => {
  const {
    standaloneUsageTracker
  } = useCardLocationContext();
  const openStartTime = useRef(I18n.moment());
  const closeStartTime = useRef(null);
  const isHubspotDefined = useMemo(() => {
    return containerFeatures.some(containerFeature => HUBSPOT_DEFINED_SECTION_CONTAINER_FEATURES.includes(containerFeature));
  }, [containerFeatures]);
  const sectionName = useMemo(() => {
    const sectionContainerFeature = containerFeatures.find(containerFeature => HUBSPOT_DEFINED_SECTION_CONTAINER_FEATURES.includes(containerFeature));
    switch (sectionContainerFeature) {
      case ABOUT_SIGNALS_SECTION_CONTAINER_FEATURE:
        return 'Signals (About Tab)';
      case ABOUT_FEEDBACK_SECTION_CONTAINER_FEATURE:
        return 'Feedback';
      case REVENUE_QUOTE_TO_CASH_SECTION_CONTAINER_FEATURE:
        return 'Quote-to-Cash';
      case REVENUE_ECOMMERCE_SECTION_CONTAINER_FEATURE:
        return 'e-Commerce';
      case REVENUE_SIGNALS_SECTION_CONTAINER_FEATURE:
        return 'Signals (Revenue Tab)';
      case CATCH_UP_OVERVIEW_SECTION_CONTAINER_FEATURE:
        return 'Overview';
      case CATCH_UP_HEALTH_SECTION_CONTAINER_FEATURE:
        return 'Health';
      case CATCH_UP_DATA_QUALITY_SECTION_CONTAINER_FEATURE:
        return 'Data Quality';
      case undefined:
      default:
        return containerLabel;
    }
  }, [containerLabel, containerFeatures]);
  return useCallback(isOpen => {
    const duration = isOpen ? closeStartTime.current && formatRelativeDuration(I18n.moment.duration(I18n.moment().diff(closeStartTime.current))) : openStartTime.current && formatRelativeDuration(I18n.moment.duration(I18n.moment().diff(openStartTime.current)));
    if (isOpen) {
      openStartTime.current = I18n.moment();
      closeStartTime.current = null;
    } else {
      closeStartTime.current = I18n.moment();
      openStartTime.current = null;
    }
    standaloneUsageTracker === null || standaloneUsageTracker === void 0 || standaloneUsageTracker.track('CRM Cards SDK', 'Crm Card Interaction', {
      action: isOpen ? 'Section expanded' : 'Section collapsed',
      name: sectionName,
      isHubspotDefined,
      duration
    });
  }, [standaloneUsageTracker, sectionName, isHubspotDefined]);
};